class Facets extends HTMLElement {
  constructor() {
    super();

    this.form = document.querySelector('.js-facets-form');

    if(this.form) {
      this.productGrid = document.querySelector('.js-collection-items') || null;

      this.form.addEventListener('input', this.debounce((event) => {
        this.handleFormChange(event);
      }, 300));

      this.minRange = document.querySelector(".js-min-price-range");
      this.maxRange = document.querySelector(".js-max-price-range");
      this.track = document.querySelector(".js-slider-track");
      this.minInput = document.querySelector(".js-price-min");
      this.maxInput = document.querySelector(".js-price-max");

      if(this.track) {
        this.minRange.addEventListener("input", () => this.updateSliderTrack());
        this.maxRange.addEventListener("input", () => this.updateSliderTrack());

        this.minInput.addEventListener("input", () => this.updateSliderFromInput());
        this.maxInput.addEventListener("input", () => this.updateSliderFromInput());

        this.updateSliderTrack();
      }

      document.querySelectorAll('.js-remove-filter').forEach(element => {
        element.addEventListener('click', (event) => this.handleRemoveFilter(event));
      });

      document.querySelectorAll('.js-facets-form input[type="checkbox"]').forEach(element => {
        element.addEventListener('change', (event) => this.handleInputChange(event));
      });

      document.querySelectorAll('.js-change-sort-by-value').forEach(element => {
        element.addEventListener('click', (event) => this.handleSortBy(event));
      });

      this.updateActiveFiltersCounter();
    } else {
      this.productGrid = document.querySelector('.js-collection-items') || null;

      document.querySelectorAll('.js-change-sort-by-value').forEach(element => {
        element.addEventListener('click', (event) => this.handleSortBy(event));
      });
    }
  }

  handleFormChange() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    
    const activeSortElement = document.querySelector('.js-change-sort-by-value.active');
    if (activeSortElement) {
      const sortValue = activeSortElement.getAttribute('data-value');
      if (sortValue) {
        searchParams.set('sort_by', sortValue);
      }
    }

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());

    const min = parseInt(this.minInput?.value || this.minRange?.min);
    const max = parseInt(this.maxInput?.value || this.maxRange?.max);
    const defaultMin = parseInt(this.minRange?.min);
    const defaultMax = parseInt(this.maxRange?.max);

    document.querySelectorAll(`.js-remove-filter[data-filter="price"]`).forEach(el => el.parentElement?.remove());

    if (min > defaultMin || max < defaultMax) {
      const label = `${Shopify.formatMoney(min * 100)} - ${Shopify.formatMoney(max * 100)}`;
      this.addActiveFilter("price", `${Shopify.formatMoney(min * 100)}-${Shopify.formatMoney(max * 100)}`, label);
    } else {
      this.removeFilterByName("price")
    }

    this.toggleLoadingClass('add');
  }

  handleSortBy(event) {
    event.preventDefault();
    const sortValue = event.currentTarget.getAttribute('data-value');
    if (!sortValue) return;
    
    let searchParams;

    if(this.form) {
      const formData = new FormData(this.form);
      searchParams = new URLSearchParams(formData);
    } else {
      searchParams = new URLSearchParams();
    }
    searchParams.set('sort_by', sortValue);

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    document.querySelectorAll('.js-change-sort-by-value').forEach(el => el.classList.remove('active'));
    event.currentTarget.classList.add('active');
    
    const currentSortDisplay = document.querySelector('.js-current-sort-by');
    if (currentSortDisplay) {
      currentSortDisplay.textContent = event.currentTarget.textContent;
    }

    this.toggleLoadingClass('add');
  }

  toggleLoadingClass(type) {
    if(type == 'add') {
      document.querySelector('.js-collection').classList.add('loading');
    } else {
      document.querySelector('.js-collection').classList.remove('loading');
    }
  }

  renderPage(searchParams) {
    const isHome = document.body.classList.contains('home');
    const currentView = new URL(window.location.href).searchParams.get('view');
    const viewParam = currentView ? `&view=${currentView}` : '';
    let url;

    if (isHome && this.productGrid) {
      const base = this.productGrid.getAttribute('data-url') || window.location.pathname;
      url = `${base}?${searchParams}${viewParam}`;
    } else {
      url = `${window.location.pathname}?${searchParams}${viewParam}`;
    }

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const productGridContent = doc.querySelector('.js-collection-items');
        if (productGridContent && this.productGrid) {
          this.productGrid.innerHTML = productGridContent.innerHTML;

          const offset = 120;
          const elementPosition = this.productGrid.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
                
        const countersFromDoc = doc.querySelectorAll('.js-products-counter');
        const countersOnPage = document.querySelectorAll('.js-products-counter');

        if (countersFromDoc.length > 0) {
          const newValue = countersFromDoc[0].innerHTML;
          countersOnPage.forEach(counterEl => {
            counterEl.innerHTML = newValue;
          });
        }

        this.toggleLoadingClass('remove');

        if (typeof initializeFadeInObserver === 'function') {
          initializeFadeInObserver();
        }

        if (typeof wishlistPage === "function") {
          wishlistPage();
        }

        if (typeof initProductGridItemColors === "function") {
          initProductGridItemColors();
        }
      })
      .catch(error => {
        console.error('Error fetching filtered results:', error);
        this.toggleLoadingClass('remove');
      });
  }

  updateSliderTrack() {
    let minVal = parseInt(this.minRange.value);
    let maxVal = parseInt(this.maxRange.value);

    const minPercent = ((minVal - this.minRange.min) / (this.minRange.max - this.minRange.min)) * 100;
    const maxPercent = ((maxVal - this.maxRange.min) / (this.maxRange.max - this.maxRange.min)) * 100;

    this.track.style.left = minPercent + "%";
    this.track.style.right = (100 - maxPercent) + "%";

    this.minInput.value = minVal;
    this.maxInput.value = maxVal;
  }

  updateSliderFromInput() {
    let minVal = parseInt(this.minInput.value);
    let maxVal = parseInt(this.maxInput.value);

    if (minVal < parseInt(this.minRange.min)) minVal = parseInt(this.minRange.min);
    if (maxVal > parseInt(this.maxRange.max)) maxVal = parseInt(this.maxRange.max);
    if (minVal > maxVal) minVal = maxVal;

    this.minRange.value = minVal;
    this.maxRange.value = maxVal;

    this.updateSliderTrack();
  }

  updateActiveFiltersCounter() {
    const activeFilters = document.querySelectorAll('.js-facets-container .js-remove-filter').length;
    document.querySelectorAll('.js-facets-clear, .js-active-filters, .js-filter-counter').forEach(element => {
      element.setAttribute('data-counter', activeFilters);
    });
  }

  addActiveFilter(filterParam, filterValue, filterLabel) {
    const activeFiltersContainers = document.querySelectorAll('.js-active-filters');
    if (!activeFiltersContainers.length) return;

    activeFiltersContainers.forEach(activeFiltersContainer => {
      let existingFilter = activeFiltersContainer.querySelector(`a[data-filter="${filterParam}"][data-value="${filterValue}"]`);
      if (existingFilter) return;

      const li = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.href = "#";
      anchor.classList.add('js-remove-filter');
      anchor.setAttribute('data-filter', filterParam);
      anchor.setAttribute('data-value', filterValue);
      anchor.innerHTML = `${filterLabel}`;

      li.appendChild(anchor);
      activeFiltersContainer.appendChild(li);

      anchor.addEventListener('click', (event) => this.handleRemoveFilter(event));
    });

    this.updateActiveFiltersCounter();
  }

  removeFilterByName(filterParam) {
    document.querySelectorAll(`.js-remove-filter[data-filter="${filterParam}"]`)
      .forEach(filter => filter.parentElement?.remove());

    if (filterParam === "price") {
      this.minRange.value = this.minRange.min;
      this.maxRange.value = this.maxRange.max;
      this.minInput.value = this.minRange.min;
      this.maxInput.value = this.maxRange.max;
      this.updateSliderTrack();
    }

    this.updateActiveFiltersCounter();
  }

  handleRemoveFilter(event) {
    event.preventDefault();
    
    const filterParam = event.currentTarget.getAttribute('data-filter');
    const filterValue = event.currentTarget.getAttribute('data-value');
    
    if (!filterParam || !filterValue) return;
    
    const checkbox = document.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);

    if (filterParam === "price") {
      this.minRange.value = this.minRange.min;
      this.maxRange.value = this.maxRange.max;
      this.minInput.value = this.minRange.min;
      this.maxInput.value = this.maxRange.max;
      this.updateSliderTrack();
    } else if (checkbox) {
      checkbox.checked = false;
    }
    
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    
    searchParams.delete(filterParam);

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    document.querySelectorAll(`.js-remove-filter[data-filter="${filterParam}"][data-value="${filterValue}"]`).forEach(filter => filter.parentElement?.remove());
    this.updateActiveFiltersCounter();

    this.toggleLoadingClass('add');
  }

  handleInputChange(event) {
    const filterParam = event.target.name;
    const filterValue = event.target.value;
    const filterLabel = event.target.dataset.label || filterValue;
    
    if (event.target.checked) {
      this.addActiveFilter(filterParam, filterValue, filterLabel);
    } else {
      document.querySelectorAll(`.js-remove-filter[data-filter="${filterParam}"][data-value="${filterValue}"]`).forEach(activeFilter => activeFilter.parentElement?.remove());
    }
    this.updateActiveFiltersCounter();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('collection-facets', Facets);